export default {
    message: {
        khmer: "ខ្មែរ",
        english: "អង់គ្លេស",
        // translate home page
        welcome: "សូមស្វាគមន៍",
        passenger: "អ្នកដំណើរ",
        bus: "កក់សំបុត្ររថយន្ត",
        speedBoat: "កក់សំបុត្រទូក",
        from: "ទិសដៅពី",
        to: "ទិសដៅទៅ",
        selectDeparture: "ជ្រើសរើសទិសដៅចេញ",
        selectDestination: "ជ្រើសរើសទិសដៅទៅ",
        departureDate: "ថ្ងៃចេញដំណើរ",
        returnDate: "ថ្ងៃត្រឡប់មកវិញ",
        selectDate: "ជ្រើសរើសថ្ងៃ",
        search: "ស្វែងរក",
        noDepartureFound: "រកមិនឃើញទិសដៅចេញ",
        noDestinationFound: "រកមិនឃើញគោលដៅទៅ",
        home: "ទំព័រដើម",
        myBooking: "ប្រវត្តិការកក់សំបុត្រ",
        information: "ព័ត៌មាន",
        plSelectDeparture: "សូមជ្រើសរើសទិសដៅចេញ",
        plSelectDestination: "សូមជ្រើសរើសទិសដៅទៅ",
        ok: "យល់ព្រម",
        // translate Ticket booking transaction
        ticketCode: "លេខកូដសំបុត្រ",
        departureDates: "ថ្ងៃខែចេញដំណើរ",
        viewDetails: "មើលព័ត៌មានលម្អិត",
        bookedDate: "ថ្ងៃកក់សំបុត្រ",
        transType: "ប្រភេទ",
        seatNumber: "លេខកៅអី",
        ticketPrice: "តម្លៃសំបុត្រ",
        subTotal: "សរុប",
        discount: "បញ្ចុះតម្លៃ",
        grandTotal: "សរុបចុងក្រោយ",
        // translate schedule list
        departureTime: "ម៉ោងចេញដំណើរ",
        arrivalTime: "ម៉ោងទៅដល់",
        remainingSeat: "ចំនួនកៅអីនៅសល់",
        seats: "កៅអី",
        booking: "កក់សំបុត្រ",
        leave: "បានចេញដំណើរ",
        sorry: "សុំទោស !",
        description: "មិនមានលទ្ធផលសម្រាប់ការស្វែងរកនេះទេ។ សូមសាកល្បងគោលដៅផ្សេងទៀត ឬកាលបរិច្ឆេទធ្វេីដំណើរ។",
        BackToSearch: "ត្រឡប់ទៅ ស្វែងរកវិញ",
        // translate choose seat
        chooseSeat: "ជ្រើសរើសកៅអី",
        free: "ទំនេរ",
        selected: "បានជ្រើសរើស",
        noAvailable: "មិនទំនេរ",
        notAvailable: "មិនទំនេរ",
        warning: "ការព្រមាន",
        descriptionSeat: "អ្នកត្រូវបានតម្រូវឲជ្រេីសរេីសកៅអីសម្រាប់គ្រប់ទីតាំងជាមួយនឹងតម្លៃកៅអីដូចគ្នាដេីម្បីបន្ដ។",
        descriptionSeatBack: "អ្នក​មិន​អាច​ជ្រើសរើស​ចំនួន​កៅអីដែល​ខុស​ពី​ការ​ជ្រើសរើស​ពីមុន​របស់​អ្នក​បាន​ទេ។ ចំនួន​កៅអី​ដែល​អ្នក​បាន​ជ្រើសរើស​គឺ",
        next: "បន្ទាប់",
        // translate passenger 
        informationNotEnough: "ព័ត៌មានមិនគ្រប់គ្រាន់ទេ",
        contactInformation: "ព័ត៌មានទំនាក់ទំនង",
        labelName: "ឈ្មោះ",
        labelTelephone: "លេខទូរស័ព្ទ",
        name: "ឈ្មោះ",
        telephone: "លេខទូរស័ព្ទ",
        selectBoardingPoint: "ចំណតឡើងជិះ",
        dropOffPoint: "ចំណតចុះ",
        customerInformation: "ព័ត៌មាន​អតិថិជន",
        gender: "ភេទ",
        national: "សញ្ជាតិ",
        male: "ប្រុស",
        female: "ស្រី",
        cambodian: "កម្ពុជា",
        foreigner: "ជនបរទេស",
        processToPayment: "ដំណើរការទៅការទូទាត់",
        alertSeatSelected: "កៅអីរបស់អ្នកបានជ្រើសរើស​ ត្រូវបានបានកក់រួចហើយ។ សូមជ្រើសរើសការធ្វើដំណើររបស់អ្នកម្តងទៀត។",
        alertWrong: "មានអ្វីមួយខុសប្រក្រតី សូមព្យាយាមម្តងទៀត។",
        // translate Payment 
        boardingPoint: "ចំណតឡើងជិះ",
        arrivalDate: "ថ្ងៃខែទៅដល់",
        travelTripFrom: "សំបុត្រធ្វើដំណើរពី",
        paymentTime: "ពេលវេលាទូទាត់",
        timeOut: "បំពេញការទូទាត់របស់អ្នកមុនពេលកំណត់",
        roundTripTicket: "សំបុត្រធ្វើដំណើរទៅ​ និងត្រលប់មកវិញ",
        travelSummary: "ព័ត៌មានសង្ខេបការធ្វើដំណើរ",
        total: "សរុប",
        payNow: "បង់ប្រាក់",
        payingWithAccount: "ជ្រើសរើសគណនីរបស់អ្នក",
        vetExpress: "VET EXPRESS",
        ask: "តើអ្នកចង់លុបចោលការកក់ទេ?",
        no: "អត់ទេ",
        yes: "បាទលុប",
        close: "បិទ",
        sessionExpired: "Session Expired",
        somethingWentWrong: "មាន​អ្វីមួយ​មិន​ប្រក្រតី",
        pleaseTryItAgain: "សូមព្យាយាមម្តងទៀត។",
        paymentNotSuccess: "ការទូទាត់មិនជោគជ័យ",
        alertInsufficientBalance: "គណនីរបស់អ្នកសមតុល្យមិនគ្រប់គ្រាន់",
        inclVat: "(បូកពន្ធអាករ)",
        paymentSummary: "សង្ខេបការទូទាត់",
        paymentSession: "អស់ពេលកាលកំណត់",
        // translate Payment Success
        msgTitle: "សំបុត្ររបស់អ្នកបានកក់រួចហើយ។",
        msg: "សូមមកដល់កន្លែងចេញដំណើរមុន 30 នាទី​។ សូមពិនិត្យមើលពត៌មានលំអិត នៅក្នុងប្រវត្តិការកក់សំបុត្រ។",
        showTicket: "បង្ហាញសំបុត្រ",
        error: "សារ",
        msgInternet: "សូមពិនិត្យមើលការតភ្ជាប់អ៊ីនធឺណិត",
        exitApp: "តើអ្នកចង់ចេញពីកម្មវិធីទេ?",
        exit: "បាទ",
        noTripFound: "រកមិនឃើញការធ្វើដំណើរទេ",
        calendar: "ប្រតិទិន",
        language: "ភាសា"
    }
}